<template>
  <div class="pt-navigation-desktop">
    <ContentSection spacing="none" class="pb-16 sm:py-28">
      <!-- HIDDEN TITLE FOR ACCESSIBILITY -->
      <h1 class="sr-only">
        {{ $t('search.search') }}
      </h1>
      <Search />
    </ContentSection>
  </div>
</template>

<script setup>
const { setIsWhite } = useNavigationStore()

onMounted(() => {
  setIsWhite(false)
})

onBeforeUnmount(() => {
  setIsWhite(false)
})
</script>
